export default __webpack_public_path__ + "static/media/circle-left.13c9e74d.svg";